import { isNil } from 'lodash';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useGetAddressesQuery } from '../../apis/mlkApi/mlk.api.hooks';
import { useLanguage } from '../../locale/useLanguage';
import { Address } from '../../models/address.models';
import { Routes } from '../../routes/types';
import { CreateOrEditAddressView } from '../CreateOrEditAddress/createOrEditAddress.view';

type EditAddressViewProps = {};

type EditAddressViewRoutingProps = {
  addressId: string;
};

export const EditAddressView: React.FC<EditAddressViewProps> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const { addressId } = useParams<EditAddressViewRoutingProps>();

  const [addressToEdit, setAddressToEdit] = useState<Address>();

  const { data } = useGetAddressesQuery(undefined);

  useEffect(() => {
    if (data) {
      const address = data.data.find((a) => a.id === +addressId);
      if (isNil(address)) {
        // TODO: Handle 404 on address gracefully
        history.replace(Routes.Home);
      } else {
        setAddressToEdit(address);
      }
    }
  }, [addressId, data, history]);

  return !addressToEdit ? null : (
    <CreateOrEditAddressView
      address={addressToEdit}
      title={t('pageTitles.editAddress')}
    />
  );
};
